import React from "react";

import ContentLoader from 'react-content-loader';

function LoadingBar() {
  let width = 100;

  return (<>
    <ContentLoader
        speed={3}
        width={400}
        height={223}
        viewBox="0 0 400 223"
        backgroundColor="#696969"
        foregroundColor="#363636"
    >
        <rect x="0" y="-1" rx="2" ry="2" width="400" height="48" />
        <rect x="0" y="58" rx="2" ry="2" width="400" height="48" />
        <rect x="0" y="116" rx="2" ry="2" width="400" height="48" />
        <rect x="0" y="174" rx="2" ry="2" width="400" height="48" />
    </ContentLoader>
  </>);
}

export default LoadingBar;
